// extracted by mini-css-extract-plugin
module.exports = {"sdMenuBg":"#36465F","sdMenuBgNew":"#fff","sdMenuColor":"#fff","sdMenuColorNew":"#000","sdMenuActiveColor":"#0091FF"};